import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function getModelCategory(requestObject, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.get("api/getModelCategory", {
      params: { clientKey: requestObject, userKey },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
